define('v3/Common/Helpers/LearningObjective/LearningObjective.NameAssembler',[], function () {
	return {
		getFullLearningObjectiveName:
			function getFullLearningObjectiveName (number, type, name, friendlyName, fullName) {
				var result = number;

				if (type) {
					result = result + ' ' + type;
				}

				result = result + '. ';

				if (friendlyName) {
					result = result + friendlyName.charAt(0).toUpperCase() + friendlyName.slice(1);
				} else if (name) {
					result = result + name.charAt(0).toUpperCase() + name.slice(1);
				} else {
					result = fullName;
				}

				return result;
			}
	};
});
